import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./ActionButton.module.css";
import { cx } from "../cx";

export type ActionButtonVariant = "brandSolid" | "neutralSolid" | "neutralWeak" | "ghost";
/** mediumTall = h48 · t4 bold · r2 (F07-16 본문 CTA 306:9666) */
export type ActionButtonSize = "large" | "mediumTall" | "medium" | "small" | "xsmall";

export type ActionButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  variant?: ActionButtonVariant;
  size?: ActionButtonSize;
  /** Stretch to container width (BottomCTA, dialogs). */
  block?: boolean;
  loading?: boolean;
  children: ReactNode;
};

/** SEED ActionButton (Figma 38:250). brandSolid = 화면당 1개 권장. */
export function ActionButton({
  variant = "brandSolid",
  size = "large",
  block = false,
  loading = false,
  className,
  disabled,
  children,
  type = "button",
  ...rest
}: ActionButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.root, styles[variant], styles[size], block && styles.block, loading && styles.loading, className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      <span className={styles.label}>{children}</span>
      {loading && <span className={styles.spinner} aria-hidden />}
    </button>
  );
}
